var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import gsap from 'gsap';
import Carousel from './Micros/Carousel';
import './CardCarousel.scss';
var CardCarousel = function (_a) {
    var data = _a.data;
    var customPolygon = "polygon(0 0%, 0 110%, 102% 100%)";
    useEffect(function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.hover-list-carousel-anime',
                start: 'top center',
            },
        });
        tl.to('.hover-list-carousel-anime', {
            autoAlpha: 1,
            duration: 1,
            stagger: {
                each: 0.1,
            },
        });
    });
    return (_jsx("div", __assign({ className: "card-carousel-section relative w-full snap-center" }, { children: _jsx("div", __assign({ className: "card-carousel-tabs relative w-full px-0 pb-8" }, { children: _jsx("div", __assign({ className: "hover-list-carousel-anime" }, { children: _jsx(Carousel, { cardsArray: data }, void 0) }), void 0) }), void 0) }), void 0));
};
export default CardCarousel;
